// extracted by mini-css-extract-plugin
export default {"component":"Portal_component__cnnHA","container":"Portal_container__5RF7G","card":"Portal_card__Ob96U","link":"Portal_link__D3ntz","title":"Portal_title__ajY5x"};